import Image from "next/image";

import { GrainOverlay } from "@/components/ui/grain-overlay";
import { cn } from "@/lib/utils";

/** Figma insights shell background (5584:26988, 10427:58082). */
export function NavPreviewBlueGradientBackground() {
  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-0 overflow-hidden bg-[rgb(214,232,255)]"
      >
        <BlueGradientEllipse
          className="top-[-120px] left-[-180px] size-[720px]"
          insetClassName="inset-[-33.1%_-26.98%]"
          src="/images/nav/insights-gradient/ellipse-5127.svg"
        />
      </div>
      <GrainOverlay
        baseFrequency={0.85}
        numOctaves={2}
        contrast={1.8}
        opacity={0.32}
        blendMode="soft-light"
      />
    </>
  );
}

function BlueGradientEllipse({
  className,
  insetClassName,
  src,
}: {
  className: string;
  insetClassName: string;
  src: string;
}) {
  return (
    <div className={cn("pointer-events-none absolute", className)}>
      <div className="relative size-full">
        <div className={cn("absolute", insetClassName)}>
          <Image
            src={src}
            alt=""
            fill
            unoptimized
            className="max-w-none object-fill"
            style={{ filter: `hue-rotate(15deg) saturate(1.15)` }}
          />
        </div>
      </div>
    </div>
  );
}

export const NAV_PREVIEW_SUBNAV_GRADIENT =
  "bg-gradient-to-b from-[rgba(249,249,248,0)] to-grey-50";
